// CSV column names match the actual file format: NAME,Class,Easting,Northing,Elevation
// Class column = locationType used when calling the API
export const LOCATION_HEADERS = {
  NAME: 'NAME',
  CLASS: 'Class',
  EASTING: 'Easting',
  NORTHING: 'Northing',
  ELEVATION: 'Elevation',
} as const;

export type LocationHeaderKey = keyof typeof LOCATION_HEADERS;

export const LOCATION_HEADER_LABELS: Record<LocationHeaderKey, string> = {
  NAME: 'Name',
  CLASS: 'Class (Location Type)',
  EASTING: 'Easting',
  NORTHING: 'Northing',
  ELEVATION: 'Elevation (m)',
};

export const REQUIRED_HEADERS: LocationHeaderKey[] = [
  'NAME',
  'CLASS',
  'EASTING',
  'NORTHING',
  'ELEVATION',
];

export const TEMPLATE_SAMPLE_ROW: Record<LocationHeaderKey, string> = {
  NAME: 'Dump C',
  CLASS: 'Dump',
  EASTING: '123500.00',
  NORTHING: '987700.00',
  ELEVATION: '460.0',
};

export const validateHeaders = (
  fileHeaders: string[]
): { valid: boolean; missing: string[] } => {
  const normalised = fileHeaders.map((h) => h.trim().toUpperCase());
  // Map expected keys to their uppercase form for comparison
  const expectedUpper: Record<LocationHeaderKey, string> = {
    NAME: 'NAME',
    CLASS: 'CLASS',
    EASTING: 'EASTING',
    NORTHING: 'NORTHING',
    ELEVATION: 'ELEVATION',
  };
  const missing = REQUIRED_HEADERS.filter(
    (h) => !normalised.includes(expectedUpper[h])
  );
  return { valid: missing.length === 0, missing };
};
